/*
 * @Author: zjw
 * @Date: 2021-05-25 14:55:52
 * @LastEditTime: 2022-11-15 18:14:05
 * @FilePath: \web-app\src\network\system\role.js
 * @Environment: Vue + Element
 * @Description: 
 */
import {
    request,
} from '../request.js'

// 角色列表
export function roleList(data) {
    return request({
        url: '/web/back/sys/role/list',
        method: 'post',
        data
    })
}
//角色分配

export function roleDistribute(data) {
    return request({
        url: '/web/back/sys/user/role/all',
        method: 'get',
        data
    })
}
// 添加
export function addRole(data) {
    return request({
        url: '/web/back/sys/role/insert',
        method: 'post',
        data
    })
}

// 修改
export function editRole(data) {
    return request({
        url: '/web/back/sys/role/update',
        method: 'post',
        data
    })
}

// 删除
export function delRole(data) {
    return request({
        url: '/web/back/sys/role/delete' + "?id=" + data,
        method: 'delete',
    })
}

// 批量删除
export function allDelRole(data) {
    return request({
        url: '/web/back/sys/role/batch/delete',
        method: 'delete',
        data
    })
}

// 获取整体树形的菜单列表
export function getTreeMenuList(data) {
    return request({
        url: '/web/back/sysMenu/tree',
        method: 'get',
        data
    })
}

// 获取整体树形的权限列表
export function getTreeAuthList(data) {
    return request({
        url: '/web/back/sys/permission/tree',
        method: 'get',
        data
    })
}

// 获取每个角色的菜单列表
export function getRoleMenuList(data) {
    return request({
        url: '/web/back/sys/role/getMenu' + "?roleId=" + data,
        method: 'get',
        data
    })
}

// 获取每个角色的权限列表
export function getRolePermissList(data) {
    return request({
        url: '/web/back/sys/role/getPermission' + "?roleId=" + data,
        method: 'get',
        data
    })
}

// 更改菜单列表
export function updateRoleMenu(data) {
    return request({
        url: '/web/back/sys/role/updateMenu',
        method: 'post',
        data
    })
}

// 更改权限列表
export function updateRolePermiss(data) {
    return request({
        url: '/web/back/sys/role/updatePermission',
        method: 'post',
        data
    })
}

